import AbstractRequestTask from '../AbstractRequestTask';

class StatusHBOTask extends AbstractRequestTask {
  constructor() {
    super();
    this.params = super.getParams();
    this.user_token = this.params.user_token;
  }

  getMethod() {
    return 'GET';
  }

  getUrl() {
    const http = "http://";
    const url = "oauth-api.clarovideo.net"
    return `${http}${url}/oauth/external/hbo/v1/status`;
  }

  getParams() {
    const params = super.getParams();   
    delete params.api_version;
    delete params.device_name;
    delete params.device_so;
    delete params.format;
    delete params.user_id;
    delete params.HKS;
    delete params.user_token;
    return Object.assign({}, params);
  }

  getHeaders() {
    return {
      'Authorization': `Bearer ${this.user_token}`,
      'Content-Type': 'application/json'
    };
  }

  isValid(response) {
    if (response && response.errors) return false;
    return true;
  }
}

export default StatusHBOTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/hbo/StatusHBOTask.js